import SessionService from '_services/common/sessionService';
import Axios from 'axios';

const axiosHeader = () => {
  const token = SessionService.getLocalData('_token');

  if (!token) {
    delete Axios.defaults.headers.common.Authorization;
    return;
  }

  Axios.defaults.headers.common.Authorization = `Bearer ${token}`;
};

export default axiosHeader;
